import type { MessageFormatElement } from '@formatjs/icu-messageformat-parser';

const SUPPORTED_LOCALES = ['en', 'ja', 'ko', 'zh-TW'] as const;
type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
type Messages = Record<string, MessageFormatElement[]> | Record<string, string>;

function localeIsSupported(code: string): code is SupportedLocale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(code);
}

// Explicit maps so Vite can statically analyze each import path > one chunk per locale/momentLocale
const messageLoaders: Partial<Record<SupportedLocale, () => Promise<{ default: Messages }>>> = {
  ja: () => import('./ja.json'),
  ko: () => import('./ko.json'),
  'zh-TW': () => import('./zh-TW.json'),
};

const momentLocaleLoaders: Partial<Record<SupportedLocale, () => Promise<unknown>>> = {
  ja: () => import('moment/dist/locale/ja'),
  ko: () => import('moment/dist/locale/ko'),
  'zh-TW': () => import('moment/dist/locale/zh-tw'),
};

async function loadLocale(locale: SupportedLocale): Promise<Messages> {
  const [msgs] = await Promise.all([
    messageLoaders[locale]?.().then((mod) => mod.default),
    momentLocaleLoaders[locale]?.(),
  ]);
  return msgs ?? {};
}

export { SUPPORTED_LOCALES, localeIsSupported, loadLocale };
export type { SupportedLocale, Messages };
